export interface TargetAndAchievement {
  category_name: string;
  total_target: number;
  total_weightage: number;
  achieved_value: number;
}

export interface CategoryPerformance {
  category: string;
  value: number;
}

export interface UpdateTimeRow {
  entity_name: string;
  last_updated_at: string;
}

export interface UpdateTime {
  [entity_name: string]: string;
}

export interface KeyPerformanceIndicators {
  first_call_tat: number;
  sales_cycle: number;
  avg_discount: number;
}

export interface Incentives {
  first_call_tat: number;
  sales_cycle: number;
  avg_discount: number;
  outbound_incentive: number;
  incentive: number;
  total_incentive: number;
}

export interface OwnerRevenueRow {
  owner_id: number;
  owner_name: string;
  total_revenue: number;
}

export interface OwnerSalesRow {
  owner_id: number;
  owner_name: string;
  total_revenue: number;
  inbound_count: number;
  outbound_count: number;
  meetings_count: number;
}

export interface SalesAnalyticsData {
  owner_sales_rows: OwnerSalesRow[];
  updated_time: UpdateTime;
  targets_and_achievements: TargetAndAchievement[];
  category_performance: CategoryPerformance[];
  key_performance_indicators: KeyPerformanceIndicators;
  incentives: Incentives;
}

export interface DailyIncentive {
  owner_name: string;
  outbound_incentive: number;
  incentive: number;
  score: number;
  total_incentive: number;
  date: string;
}

export interface Owner {
  id: number;
  value: string;
  name?: string;
}
// 1 means closed
export enum PipelineStage {
  CLOSED = 1,
  WON = 100,
  LOST = 75,
  QUALIFIED = 50,
  DECLINED = 25,
  OPEN = 0,
}

export const pipelineStages = [
  PipelineStage.CLOSED,
  PipelineStage.WON,
  PipelineStage.LOST,
  PipelineStage.QUALIFIED,
  PipelineStage.DECLINED,
  PipelineStage.OPEN,
];
